const addKey = "add-json-proxy";

const addApplicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/-1$/);
};

const addModify = (resp) => {
	if(resp.status !== 400 && resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	resp.data.Data = {
		Id: -1,
		Code: "json-test",
		Name: "Test Json Response",
		Method: "POST",
		Type: {
			Id: 3,
			Code: "QUERY",
			Name: "Query",
			Description: "Query / Get Information"
		}	
	};

	return resp;
};

const handleKey = "handle-json-proxy";

const handleApplicable = (resp) => {
	return resp.config.method === "POST" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/json-test$/);
};

const handleModify = (resp) => {
	if(resp.status !== 400 && resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	resp.data.Data = {
		Body: {
			Action: "JSON",
			Content: `{	
				"testing": "abc123",
				"id": 4,
				"paul": "great",
				"array": [
					1, 2, 3, 4
				]
			}`,
			MediaType: "application/json",
			Name: undefined
		}	
	};

	return resp;
};

export const addProxyJson = [addKey, addApplicable, addModify];
export const handleProxyJson = [handleKey, handleApplicable, handleModify];